import FoughalTransactionsScreen from './FoughalTransactionsScreen';

export default FoughalTransactionsScreen;
